export function isNumber(n) {
  return typeof n === 'number';
}